export function getResponsibleName(empresa, accountants, admins) {
	if (empresa?.accountantId) {
		const accountant = accountants?.find((a) => a.id === empresa.accountantId);
		return accountant ? accountant.name : "No asignado";
	} else if (empresa?.adminId) {
		const admin = admins?.find((a) => a.id === empresa.adminId);
		return admin ? admin.name : "No asignado";
	}
	return "No asignado";
}
